<template>
  <div>
    <div class="container">
      <ul class="ul-new" v-if="newList.length>0">
        <li v-for="(item,index) in newList" :key="index" @click="newClick(item)">
          <div class="read-item">
            <div class="new-item">
              <span id="title">{{item.infoTitle}}</span>
              <span id="time">{{item.createTime.substring(0,10)}}</span>
            </div>
            <!-- <p style='text-indent:32px;line-height:26px;margin:5px 0px;font-size: 16px;'></p> -->
          </div>
        </li>
      </ul>
      <el-pagination v-if="totalPage > 10" class="pagination" background layout="prev, pager, next" :current-page="currentPageNo"
          @current-change="pageChange" :total="totalPage">
        </el-pagination>
        <div class="empty-container" v-if="!newList || newList.length == 0">
          <span>暂时没有文章</span>
        </div>
    </div>
    <el-dialog title="微信支付10元" :visible.sync="qrcodeVisble" width="360px" :close-on-click-modal='dialogClosable'>
        <div class="dialog-wrapper">
            <img style="width: 300px;height: 407px;" src="../../../static/image/wjt_pay.jpg"/>
        </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data(){
    return {
      pageSize:8,
      currentPageNo: 1,
      totalPage: 1,
      newList:[],
      qrcodeVisble:false,
      dialogClosable:true
    }
  },
  created(){
    this.getNews()
  },
  methods:{
    getNews(){
      this.wjtHttp.get(this,'/api/home/v1/payInfo?pageNum='+this.currentPageNo+'&pageSize='+this.pageSize,{},false,(res)=>{
        var data = res.data
        if(data.code == 200){
          this.newList = data.rows
          this.totalPage = Math.ceil(data.total / 8) * 10
        }else{
            this.$message({
                message:(data.msg&&data.msg.length > 0)?data.msg:'内容获取异常，请联系管理员',
                type:'error'
            })
        }
      })
    },
    pageChange(pageNo) {
        this.currentPageNo = pageNo
        this.getNews()
    },
    newClick(item){
      this.qrcodeVisble =  true
    }
  }
}
</script>

<style scoped>
.container{
  width: 800px;
  min-height: 520px;
  margin: auto auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px auto;
}
.ul-new{
  list-style: square;
  width: 100%;
}
.ul-new>li{
  width: 100%;
  height: 50px;
  cursor: pointer;
}
.read-item{
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: #333333;
  border-bottom-style: solid;
  border-color: #E6E6E6;
  border-width: 1px;
}
.dialog-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.new-item{
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 18px;
}
.new-item:hover{
  color: #156098;
}
#title{
  width: 70%;
  text-align: left;
}
#time{
  width: 30%;
  text-align: right;
}
.empty-container {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-container>span {
  font-size: 20px;
  color: #AEAEAE;
}
.pagination {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Read.vue